import BlockComponentText from '../../../models/BlockComponentValues/BlockComponentText';
import LinkData from '../../../models/LinkData';
import BlockComponentImage from '../../../models/BlockComponentValues/BlockComponentImage';

class BlockFooterData {
  title?: BlockComponentText;
  menus?: LinkData[];
  url?: BlockComponentImage;
  isFree?: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace BlockFooterData {
  export function make(isFree?: boolean, title?: string, menus?: LinkData[], url?: string): BlockFooterData {
    return {
      isFree,
      title: title ? BlockComponentText.make(title) : undefined,
      menus,
      url: BlockComponentImage.make(url),
    };
  }

  export function getDefault(isFree = false, title: string = undefined): BlockFooterData {
    return make(
      isFree,
      `<p>${title}</p>`,
      [
        LinkData.getDefault('メニュー1'),
        LinkData.getDefault('メニュー2'),
        LinkData.getDefault('メニュー3'),
      ],
    );
  }
}

export default BlockFooterData;
